import React from 'react';

interface LoadingFallbackProps {
  message?: string;
  subMessage?: string;
}

const LoadingFallback: React.FC<LoadingFallbackProps> = ({
  message = 'Chúng tôi đang tải dữ liệu...',
  subMessage = 'Vui lòng chờ trong giây lát...',
}) => {
  return (
    <div className='fixed inset-0 bg-[var(--textGray50)]  flex justify-center items-center z-50'>
      <div className='text-center p-8 max-w-md'>
        <div className='relative w-16 h-16 mx-auto mb-4'>
          <svg className='animate-spin' viewBox='0 0 50 50' width='100%' height='100%'>
            <circle cx='25' cy='25' r='20' fill='none' strokeWidth='4' stroke='#e6f4ff' />
            <circle
              cx='25'
              cy='25'
              r='20'
              fill='none'
              strokeWidth='4'
              stroke='var(--primaryColor)'
              strokeLinecap='round'
              strokeDasharray='30 126'
              strokeDashoffset='0'
            />
          </svg>
        </div>

        <h2 className='text-[20px] leading-[28px] font-bold text-[var(--greyTextColor)] mt-6'>{message}</h2>
        <p className='text-[var(--greyTextColor)] text-[14px] leading-[22px]'>{subMessage}</p>
      </div>
    </div>
  );
};

export default LoadingFallback;
